import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const fixShopperAgentStrategyGuidance = {
  name: "fixShopperAgentStrategyGuidance" as const,
  input: z.object({
    guidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
    issue: z.object({
      start: z.number().int(),
      end: z.number().int(),
      message: z.string(),
      kind: z.string().optional(),
    }),
  }),
  output: z.object({
    /** Offsets into `guidance`; null when no fix could be written. */
    fix: z
      .object({
        start: z.number().int(),
        end: z.number().int(),
        replacement: z.string(),
      })
      .nullable(),
  }),
};
